import React from 'react';
import AppBar from 'material-ui/AppBar';
import FlatButton from 'material-ui/FlatButton';
import {openDrawer} from "../../../actions/shared/actions_shared_1";
import AuthService from "../../../services/AuthService";

export default class CustomAppBar extends React.Component {

    constructor(props) {
        super(props);
        this.Auth = new AuthService();
    }

    render() {
        return (
            <AppBar
                title={<span>{this.props.title}</span>}
                titleStyle={{cursor: "pointer"}}
                onTitleClick={() => this.props.history.push(this.props.titlePath)}
                onLeftIconButtonClick={() => !this.props.disableLeftClick && this.props.dispatch(openDrawer())}
                iconElementRight=
                    {<FlatButton
                        label="Se déconnecter"
                        className="no-print"
                        onClick={() => {
                            this.props.history.push('/');
                            this.Auth.logout();
                        }}
                    />}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/utils/CustomAppBar.js